import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BlogPost } from '../models/blogpost';
import { environment } from '../../environments/environment';
import { iHttpPaginatedResponse } from '../interfaces/iHttpPaginatedResponse';

@Injectable({
  providedIn: 'root'
})
export class BlogService {

  constructor(
    private _http: HttpClient
  ) { }

  public getAll(page,pp,filters):Observable<iHttpPaginatedResponse>{
    return this._http.get<iHttpPaginatedResponse>(environment.apiEndpoint + `/api/admin/blog?page=${page}&pp=${pp}&${filters}`).pipe(
      map(res => {
        return res;
      })
    );
  }

  public getPost(id:number):Observable<any>{
    return this._http.get(environment.apiEndpoint+'/api/admin/blog/'+id).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public deletePost(id:number):Observable<any>{
    return this._http.delete(environment.apiEndpoint+'/api/admin/blog/'+id).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public createPost(post:BlogPost):Observable<any>{
    return this._http.post(environment.apiEndpoint+'/api/admin/blog', {post:post}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public updatePost(post:BlogPost):Observable<any>{
    return this._http.put(environment.apiEndpoint+'/api/admin/blog', {post:post}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }
}
